import React from 'react';
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import NoData from './noDataFound.json'

function CommonNoDataFound(props) {
  return (
    <div >
      <Player
        autoplay
        loop
        src={NoData}
        style={{ height: props?.height ? props?.height : '70vh', width: '120px' }}
      >
        <Controls visible={false} buttons={['play', 'repeat', 'frame', 'debug']} />
      </Player>
      <div>
    </div>
    </div>
  )
}

export default CommonNoDataFound